<fieldset [disabled]="(contractDataService.subContractFormState | async )==='Submitting'">

  <div class="rm-menu"    
  [class.edited]="contractDataService.subContractEdited | async"
  (mouseout)="removeNewStepPreview ()"   >

  <div class="rm-menu-edited-block"  *ngIf="contractDataService.subContractEdited | async">
    <div class="rm-menu-edited-block-label"> {{'CONTRACTS.CARD.CONTRACT_CHANGED' | translate}} </div>
    <div class="rm-menu-edited-block-buttons">
      <button (click)="saveChangedData()" data-action="saveChangedData" 
        class="button-icon size-xs accent-button" >
        <mat-icon svgIcon="save-2-fill"></mat-icon>
        {{'CONTRACTS.CARD.SAVE' | translate}}
      </button>
      <button (click)="cancelChangedData()" data-action="cancelChangedData" 
        class="button-icon size-xs white-button" style="min-width: 92px !important;">
        <mat-icon svgIcon="close-fill"></mat-icon>
        {{'CONTRACTS.CARD.CANCEL' | translate}}
      </button>
    </div>
  </div>
<!--     <div class="rm-menu-cancel" 
      (click)="cancelChangedData()">
      <div class="rm-menu-add-step-item" *ngIf="contractDataService.subContractEdited | async">
        <img [src]="'../../../../../assets/images/contract/step-icons/close-line.svg'">
        <span class="rm-menu-add-step-item-label">{{'CONTRACTS.CARD.CANCEL' | translate}}</span>
      </div>
    </div> -->
    <div class="rm-menu-add-step" *ngIf="ContractStatusToModifyRM.includes(contractStatus)">
        <button class="rm-menu-add-step-item" 
          *ngFor="let item of stepsStylingMap"
          (click)="addNewStep(item.key)"  >
          <img  class="rm-menu-add-step-item-img"
            (mouseleave)="removeNewStepPreview ()" 
            (mouseenter)="showNewStepPreview(item.key,$event)"
              [src]="'../../../../../assets/icons/' + item.value?.stepIcon +'.svg'">
            <div class="rm-menu-add-step-item-label">{{'CONTRACTS.CARD.STEPS.'+item.key | translate}}
          </div>
        </button>
    </div>
<!--     <div class="rm-menu-save" 
      (click)="saveChangedData()">
      <div class="rm-menu-add-step-item"  *ngIf="this.contractDataService.subContractEdited | async">
        <img [src]="'../../../../../assets/images/contract/step-icons/save-2-fill.svg'">
        <span class="rm-menu-add-step-item-label">{{'CONTRACTS.CARD.SAVE' | translate}}</span>
      </div>
    </div> -->
  </div>
</fieldset>